import IField, {FieldBehaviors, FieldType} from "../IField";
import IFieldVisitor from "../IFieldVisitor";

export default class ArrayField implements IField {
    
    public readonly id: string;
    public readonly name: string;
    public readonly type: FieldType = FieldType.Array;
    public readonly innerField: IField;
    public readonly nullable: boolean;
    public readonly searchable: boolean;
    public readonly order: number;
    public readonly behaviors: FieldBehaviors;

    /* tslint:disable-next-line:variable-name */
    public readonly __typename: string = "ArrayField";

    constructor(id: string, name: string, order: number, innerField: IField, nullable=false, behaviors = FieldBehaviors.None) {
        this.id = id;
        this.name = name;
        this.innerField = innerField;
        this.behaviors = behaviors;
        this.searchable = innerField.searchable;
        this.nullable = nullable;
        this.order = order;
    }

    public accept<T>(visitor: IFieldVisitor<T>): T {
        return visitor.visit(this);
    }

    
}


// WEBPACK FOOTER //
// ./src/metamodel/Fields/ArrayField.ts